import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './ScrollControls.module.css';

const ScrollControls = ({
  containerRef,
  className,
  rootClassName,
  showLeft = true,
  showRight = true,
  theme = 'light',
}) => {
  const scrollLeft = () => {
    if (containerRef?.current) {
      containerRef.current.scrollBy({
        left: -320, // Scroll by approximately one card width
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (containerRef?.current) {
      containerRef.current.scrollBy({
        left: 320, // Scroll by approximately one card width
        behavior: 'smooth',
      });
    }
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      {showLeft && (
        <button
          className={classNames(css.scrollButton, { [css.dark]: theme === 'dark' })}
          onClick={scrollLeft}
          aria-label="Scroll left"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M10 12L6 8L10 4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
      {showRight && (
        <button
          className={classNames(css.scrollButton, { [css.dark]: theme === 'dark' })}
          onClick={scrollRight}
          aria-label="Scroll right"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M6 4L10 8L6 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

ScrollControls.propTypes = {
  containerRef: PropTypes.object,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  showLeft: PropTypes.bool,
  showRight: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']),
};

export default ScrollControls;
